/** Calendar weekdays 0=Sun … 6=Sat (matches backend / work-hour rules). */
export const WEEKDAY_ORDER = [1, 2, 3, 4, 5, 6, 0]; // Mon→Sun UI order

export const WEEKDAY_LABEL_KEYS = {
  0: 'weekdaySunShort',
  1: 'weekdayMonShort',
  2: 'weekdayTueShort',
  3: 'weekdayWedShort',
  4: 'weekdayThuShort',
  5: 'weekdayFriShort',
  6: 'weekdaySatShort'
};

export const WEEKDAY_FULL_KEYS = {
  0: 'weekdaySun',
  1: 'weekdayMon',
  2: 'weekdayTue',
  3: 'weekdayWed',
  4: 'weekdayThu',
  5: 'weekdayFri',
  6: 'weekdaySat'
};

export const normalizeWeekdays = (raw) => {
  if (!Array.isArray(raw)) {
    return [];
  }
  return [...new Set(raw.map((day) => Number(day)).filter((day) => day >= 0 && day <= 6))]
    .sort((a, b) => a - b);
};

export const toggleWeekday = (selected, day) => {
  const current = normalizeWeekdays(selected);
  if (current.includes(day)) {
    return current.filter((value) => value !== day);
  }
  return normalizeWeekdays([...current, day]);
};

/** Localized list e.g. "Mon, Wed, Fri" using tasks: weekday keys via `t`. */
export const formatWeekdayList = (weekdays, t, { namespace = 'tasks', full = true } = {}) => {
  const days = normalizeWeekdays(weekdays);
  if (days.length === 0) {
    return '';
  }
  const keys = full ? WEEKDAY_FULL_KEYS : WEEKDAY_LABEL_KEYS;
  const ordered = WEEKDAY_ORDER.filter((day) => days.includes(day));
  return ordered.map((day) => t(`${namespace}:${keys[day]}`)).join(', ');
};

export const formatTaskRecurrence = (taskOrPreset, t) => {
  const weekdays = normalizeWeekdays(
    taskOrPreset?.recurrence_weekdays || taskOrPreset?.recurrenceWeekdays
  );
  if (taskOrPreset?.recurrence_enabled || taskOrPreset?.recurrenceEnabled) {
    if (weekdays.length > 0) {
      return formatWeekdayList(weekdays, t);
    }
    const interval = taskOrPreset.recurrence_interval_days || taskOrPreset.recurrenceIntervalDays;
    if (interval) {
      return t('presets:recurrenceEvery', { count: Number(interval) });
    }
  }
  return t('presets:recurrenceNo');
};
